document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.getElementById('priceSearchInput');
    const categories = document.querySelectorAll('.js-search-category');
    const noResultsMsg = document.getElementById('priceNoResults');

    if (!searchInput) return;

    searchInput.addEventListener('input', function (e) {
        const query = e.target.value.toLowerCase().trim();
        let globalMatchFound = false;

        categories.forEach(category => {
            const content = category.querySelector('.accordeon__content');
            const rows = category.querySelectorAll('.js-search-row');
            const headRow = category.querySelector('.accordeon__head-row');
            const subcategoryHeadings = category.querySelectorAll('.js-search-subcategory');
            let hasVisibleRows = false;

            if (query === '') {
                // Reset: collapse everything, show all rows and subcategory headings.
                category.classList.remove('hidden');
                category.classList.remove('is-active');
                category.classList.remove('is-searching');
                rows.forEach(r => r.classList.remove('hidden'));
                if (headRow) headRow.classList.remove('hidden');
                subcategoryHeadings.forEach(h => h.classList.remove('hidden'));

                if (content) {
                    content.style.maxHeight = '';
                }
                return;
            }

            // Check each service row for a match.
            rows.forEach(row => {
                const textEl = row.querySelector('.js-search-text');
                if (!textEl) return;

                const text = textEl.textContent.toLowerCase();

                if (text.includes(query)) {
                    row.classList.remove('hidden');
                    hasVisibleRows = true;
                    globalMatchFound = true;
                } else {
                    row.classList.add('hidden');
                }
            });

            // Keep only subcategory headings that group visible search results.
            if (headRow) headRow.classList.add('hidden');
            subcategoryHeadings.forEach(heading => {
                let sibling = heading.nextElementSibling;
                let hasVisibleRow = false;

                while (sibling && !sibling.classList.contains('js-search-subcategory')) {
                    if (sibling.classList.contains('js-search-row') && !sibling.classList.contains('hidden')) {
                        hasVisibleRow = true;
                        break;
                    }

                    sibling = sibling.nextElementSibling;
                }

                heading.classList.toggle('hidden', !hasVisibleRow);
            });

            if (hasVisibleRows) {
                category.classList.remove('hidden');
                category.classList.add('is-active');
                category.classList.add('is-searching');

                if (content) {
                    content.style.maxHeight = 'none';
                }
            } else {
                category.classList.add('hidden');
                category.classList.remove('is-active');
                category.classList.remove('is-searching');

                if (content) {
                    content.style.maxHeight = '';
                }
            }
        });

        if (noResultsMsg) {
            if (!globalMatchFound && query !== '') {
                noResultsMsg.classList.remove('hidden');
            } else {
                noResultsMsg.classList.add('hidden');
            }
        }
    });
});
